import React from 'react';

import {
  BookmarkIcon, FlagIcon, ReadingIcon,
  AudioIcon, AllBooksIcon, LockedBooksIcon,
} from 'rebook/apps/base/components/icons/BookIconTransparent';

import styles from './style.scss';


const TEXT_BOOKS_TEXTS = {
  0: {
    text: 'Откладывайте книги<br>на потом, чтобы<br>не потерять важное.',
    icon: <AllBooksIcon />,
  },
  1: {
    text: 'Откладывайте книги<br>на потом, чтобы<br>не потерять важное.',
    icon: <BookmarkIcon />,
  },
  2: {
    text: 'Здесь будут книги,<br>которые вы откроете<br>в режиме чтения.',
    icon: <ReadingIcon />,
  },
  3: {
    text: 'Дочитывайте до конца<br>и собирайте коллекцию',
    icon: <FlagIcon />,
  },
  5: {
    text: 'Здесь будут книги,<br>которые скоро станут<br>недоступны.',
    icon: <LockedBooksIcon />,
  },
};

const AUDIO_BOOKS_TEXTS = {
  0: {
    text: 'Откладывайте книги<br>на потом, чтобы<br>не потерять важное.',
    icon: <AllBooksIcon />,
  },
  1: {
    text: 'Откладывайте книги<br>на потом, чтобы<br>не потерять важное.',
    icon: <BookmarkIcon />,
  },
  2: {
    text: 'Здесь будут книги,<br>которые вы откроете<br>в режиме прослушивания.',
    icon: <AudioIcon />,
  },
  3: {
    text: 'Дослушивайте до конца<br>и собирайте коллекцию',
    icon: <FlagIcon />,
  },
  5: {
    text: 'Здесь будут книги,<br>которые скоро станут<br>недоступны.',
    icon: <LockedBooksIcon />,
  },
};

const UserProfileViewBooksEmpty = (props) => {
  const { type, status } = props;
  const textsDict = type === 'audio' ? AUDIO_BOOKS_TEXTS : TEXT_BOOKS_TEXTS;
  return (
    <div className={styles.container}>
      {textsDict[status].icon}
      <div
        className={styles.text}
        dangerouslySetInnerHTML={{ __html: textsDict[status].text }} />
    </div>
  );
};

export default UserProfileViewBooksEmpty;
